// eslint-disable-next-line jira/restricted/react-component-props
import React, { type ComponentProps } from 'react';
import { css, styled } from '@compiled/react';
import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';

const ButtonProxy = ({ children, ...rest }: ComponentProps<'button'>) => (
	<Proxy {...rest}>
		{children}
		{/* OutlineCapture prevents clicks showing outline */}
		<OutlineCapture tabIndex={-1} />
	</Proxy>
);

export default ButtonProxy;

// eslint-disable-next-line @compiled/no-exported-css, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const absoluteFillAreaStyles: ReturnType<typeof css> = css({
	position: 'absolute',
	top: 0,
	bottom: 0,
	left: 0,
	right: 0,
});

const focusRingStyles = css({
	outline: 'none',
	'&:focus': {
		/* Atlaskit focus ring surrounds outside the element which makes it get cut off  */

		boxShadow: `
${/* eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766 */ ''}
            inset 2px 2px ${token('color.border.focused', colors.B100)},
${/* eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766 */ ''}
            inset -2px -2px ${token('color.border.focused', colors.B100)}`,
	},
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const OutlineCapture = styled.div({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	...absoluteFillAreaStyles,
	'&:focus': {
		outline: 'none',
	},
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Proxy = styled.button({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	...focusRingStyles,
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	flexShrink: 0,
	alignSelf: 'stretch',
	cursor: 'pointer',

	position: 'relative',
	border: 'none',
	background: 'none',
	padding: 0,
});
